var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-expansion-panel',{staticClass:"guideline-expansion-panel",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var title = ref.title;
return [_c('div',[_vm._v(_vm._s(title))])]}},{key:"content",fn:function(ref){
var content = ref.content;
return [_c('div',{domProps:{"innerHTML":_vm._s(content)}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }